export * from '../src/modal/w3m-modal/index.js';
//# sourceMappingURL=w3m-modal.js.map